<script>
import { mapState } from 'vuex'

export default {
    name: 'CardKBCall',
    props: {
        card: Object
    },
    computed: {
        ...mapState('debug', ['cardActive']),
        variables () {
            return Object.entries(this.card.config.variables).map(o => {
                return {
                    key: o[0],
                    value: o[1]
                }
            })
        },
        response () {
            return [
                this.cardActive.response
            ]
        }
    }
}
</script>

<template>
    <div class="d-flex flex-column" style="gap: 12px">
        <div class="d-flex font-weight-bold" style="gap: 8px">Intent:
            <div class="intent-item font-weight-medium">{{ card.config.intent }}</div>
        </div>
        <span class="font-weight-bold">Entities:</span>
        <el-table border :data="card.config.entities" show-overflow-tooltip>
            <el-table-column
                prop="entity"
                label="Loại thực thể">
            </el-table-column>
            <el-table-column
                prop="value"
                label="Giá trị">
            </el-table-column>
            <el-table-column
                prop="real_value"
                label="Giá trị thực">
            </el-table-column>
        </el-table>
        <span class="font-weight-bold">Variables:</span>
        <el-table border :data="variables" show-overflow-tooltip>
            <el-table-column
                    prop="key"
                    label="Biến">
            </el-table-column>
            <el-table-column
                    prop="value"
                    label="Giá trị">
            </el-table-column>
        </el-table>
        <v-divider/>
        <span class="font-weight-bold">Response:</span>
        <el-table border show-overflow-tooltip :data="response">
            <el-table-column
                    width="100"
                    align="center"
                    prop="status"
                    label="Http Code">
            </el-table-column>
            <el-table-column
                    prop="response_body"
                    label="Phản hồi">
                <template slot-scope="scope">
                  <json-viewer
                      v-if="scope.row.response_body"
                      :value="JSON.parse(scope.row.response_body)"
                      :expand-depth=5
                      copyable
                      boxed
                      sort>
                  </json-viewer>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<style scoped lang="scss">
.intent-item {
    border-radius: 4px;
    background: #D7E3FC;
    padding: 0px 6px;
    color: #204084;
    line-height: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 250px;
}
</style>
